import { StatusBoletoEnum } from "resources/enums/conta";
import IconWrapper from "./IconWrapper/IconWrapper";

interface FiltroTipoStatusProps {
  selectedTipoStatus?: string;
  setSelectedTipoStatus?: (id?: string) => any;
}

export default function FiltroTagStatus({
  selectedTipoStatus,
  setSelectedTipoStatus,
}: FiltroTipoStatusProps) {
  const onSelectTipoStatus = (t: string) => {
    if (selectedTipoStatus === t) {
      setSelectedTipoStatus?.(undefined);
    } else {
      setSelectedTipoStatus?.(t);
    }
  };

  const items = StatusBoletoEnum;
  return (
    <>
      {(Object.keys(items) as (keyof typeof items)[]).map((key) => (
        <IconWrapper
          onClick={() => onSelectTipoStatus?.(items[key])}
          selected={selectedTipoStatus === items[key]}
        >
          {getTextForKey(key)}
        </IconWrapper>
      ))}
    </>
  );
}

const getTextForKey = (key: keyof typeof StatusBoletoEnum) => {
  switch (key) {
    case "AguardandoRemessa":
      return "Aguardando Remessa";
    case "AguardandoRegistro":
      return "Aguardando Registro";
    case "EmCancelamento":
      return "Em Cancelamento";
    case "Disponivel":
      return "Disponível";
    default:
      return key;
  }
};
